import { useState } from "react";
import { Icon } from "./Icon.js";

/** A small inline chip list with add (Enter / comma / blur) and per-chip remove.
 * Used for aliases, tags, and other comma-separated fields. */
export function ChipEditor({ chips, onChange, placeholder, accent }: {
  chips: string[];
  onChange: (next: string[]) => void;
  placeholder?: string;
  accent?: boolean;
}) {
  const [draft, setDraft] = useState("");
  const add = () => {
    const v = draft.trim();
    if (!v) return;
    if (chips.some((c) => c.toLowerCase() === v.toLowerCase())) { setDraft(""); return; }
    onChange([...chips, v]);
    setDraft("");
  };
  return (
    <div className="chip-editor">
      {chips.map((c, i) => (
        <span key={i} className={`chip-edit ${accent ? "chip-accent" : ""}`}>
          {c}
          <button onClick={() => onChange(chips.filter((_, j) => j !== i))} title="Remove"><Icon name="x" size={11} /></button>
        </span>
      ))}
      <input
        className="chip-input"
        value={draft}
        placeholder={placeholder}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } }}
        onBlur={add}
      />
    </div>
  );
}

/** Parse a comma/semicolon/newline-separated string into trimmed, non-empty parts. */
export function parseList(raw: unknown): string[] {
  const s = typeof raw === "string" ? raw : "";
  if (!s.trim()) return [];
  return s.split(/[,;\n]/).map((t) => t.trim()).filter(Boolean);
}
